import { useEffect, useRef } from 'react';
import cx from 'classnames';
import { useIsRTL } from '../../../locale';
import { getRTLOffsetType } from '../domHelpers';
import cn from './VirtualScrollbar.css.json';
import './VirtualScrollbar.css';
import { jsx as _jsx } from "react/jsx-runtime";
export const VirtualScrollbar = props => {
  const {
    dir,
    onScroll,
    size,
    className,
    ...otherProps
  } = props;
  const isRTL = useIsRTL();
  const isHorizontal = dir === 'horizontal';
  const styleProp = isHorizontal ? 'width' : 'height';
  const scrollProp = isHorizontal ? 'scrollLeft' : 'scrollTop';
  const ref = useRef(null);
  // consumers will sometimes want to specify where the bar has scrolled to
  const value = props.value ?? 0;
  useEffect(() => {
    if (!ref.current) return;
    const scrollPos = isHorizontal ? getActualScrollLeft({
      normalizedScrollLeft: value,
      direction: isRTL ? 'rtl' : 'ltr',
      scrollWidth: ref.current.scrollWidth,
      clientWidth: ref.current.clientWidth
    }) : value;
    if (ref.current[scrollProp] !== scrollPos) {
      ref.current[scrollProp] = scrollPos;
    }
  }, [value, scrollProp, isHorizontal, isRTL]);
  return /*#__PURE__*/_jsx("div", {
    ref: ref,
    className: cx(cn.container, {
      [cn.hbar]: isHorizontal,
      [cn.vbar]: !isHorizontal
    }, className),
    onScroll: props.onScroll,
    ...otherProps,
    children: /*#__PURE__*/_jsx("div", {
      className: cn.body,
      style: {
        [styleProp]: size
      }
    })
  });
};
export default VirtualScrollbar;
export const getActualScrollLeft = args => {
  const {
    normalizedScrollLeft,
    direction,
    scrollWidth,
    clientWidth
  } = args;
  if (direction === 'ltr') return Math.max(0, normalizedScrollLeft);
  switch (getRTLOffsetType()) {
    case 'negative':
      return -normalizedScrollLeft;
    case 'positive-descending':
      return scrollWidth - clientWidth - normalizedScrollLeft;
  }
  return normalizedScrollLeft;
};
//# sourceMappingURL=VirtualScrollbar.js.map